import ConsultCaseListPage from './ConsultCaseListPage';

export const ConsultCaseListPageConfig = {
  routes: [
    {
      path: '/pages/consult/case',
      exact: true,
      component: ConsultCaseListPage,
    },
  ],
};
